export const NAVIGATION_MAIN_ICON_LINK_TARGET_BLANK = "_blank";
export const NAVIGATION_MAIN_ICON_LINK_TARGET_SELF = "_self";
export const NAVIGATION_MAIN_ICON_LINK_TARGET_PARENT = "_parent";
export const NAVIGATION_MAIN_ICON_LINK_TARGET_TOP = "_top";
export const NAVIGATION_MAIN_ICON_LINK_TARGETS = [
  NAVIGATION_MAIN_ICON_LINK_TARGET_BLANK,
  NAVIGATION_MAIN_ICON_LINK_TARGET_SELF,
  NAVIGATION_MAIN_ICON_LINK_TARGET_PARENT,
  NAVIGATION_MAIN_ICON_LINK_TARGET_TOP
] as const;
